<template>
    <div class="c-m-pagination" v-if="pages.length > 1">
        <ul class="c-m-pagination__list c-m-pagination__list--small">
            <li class="c-m-pagination__button c-m-pagination__button--prev" @click="go(currentPage - 1)" v-if="showPrevButton"><icon :icon="'arrow_back'"/> <span class="c-m-pagination__label">Föregående</span></li>
            <li class="c-m-pagination__button c-m-pagination__button--prev c-m-pagination__button--disabled" v-else><icon :icon="'arrow_back'"/> <span class="c-m-pagination__label">Föregående</span></li>
            <li
                :key="`page-${currentPage}`"
                class="c-m-pagination__item c-m-pagination__item--active"
            >
                Sida {{currentPage}}
            </li>
            <li class="c-m-pagination__button c-m-pagination__button--next" @click="go(currentPage + 1)" v-if="showNextButton"><span class="c-m-pagination__label">Nästa</span> <icon :icon="'arrow_forward'"/></li>
            <li class="c-m-pagination__button c-m-pagination__button--next c-m-pagination__button--disabled" v-else><span class="c-m-pagination__label">Nästa</span> <icon :icon="'arrow_forward'"/></li>
        </ul>
        <ul class="c-m-pagination__list c-m-pagination__list--large">
            <li class="c-m-pagination__button c-m-pagination__button--prev" @click="go(currentPage - 1)" v-if="showPrevButton"><icon :icon="'arrow_back'"/> <span class="c-m-pagination__label">Föregående</span></li>
            <li class="c-m-pagination__button c-m-pagination__button--prev c-m-pagination__button--disabled" v-else><icon :icon="'arrow_back'"/> <span class="c-m-pagination__label">Föregående</span></li>
            <li
                v-for="index in pages" :key="`page-${index}`"
                class="c-m-pagination__item"
                @click="go(index)"
                :class="{'c-m-pagination__item--active': currentPage === index }">
                {{index}}
            </li>
            <li class="c-m-pagination__button c-m-pagination__button--next" @click="go(currentPage + 1)" v-if="showNextButton"><span class="c-m-pagination__label">Nästa</span> <icon :icon="'arrow_forward'"/></li>
            <li class="c-m-pagination__button c-m-pagination__button--next c-m-pagination__button--disabled" v-else><span class="c-m-pagination__label">Nästa</span> <icon :icon="'arrow_forward'"/></li>
        </ul>
    </div>
</template>
<script>
    import Icon from '../atoms/AtomIcon.vue'
    import PageButton from '../atoms/AtomButton.vue'

    export default {
        props: [
            'totalItemsProp',
            'itemsPerPageProp',
            'currentPageProp',
            'maxPagesToShowProp'
        ],
        components: {
            Icon,
            PageButton
        },
        computed:{
            // The number of items to show for each page
            itemsPerPage: function(){
                return this.itemsPerPageProp ? parseInt(this.itemsPerPageProp) : 10;
            },
            // The total number of items
            totalItems: function(){
                return this.totalItemsProp ? parseInt(this.totalItemsProp) : 0;
            },
            // The total number of pages
            totalPages: function(){
                return Math.ceil(this.totalItems / this.itemsPerPage) ? Math.ceil(this.totalItems / this.itemsPerPage) : 1
            },
            // What's the currently active page?
            currentPage: function(){
                return parseInt(this.currentPageProp) || 1;
            },
            // Decides how many paging items to show at once (at most)
            maxPagesToShow: function() {
                return parseInt(this.maxPagesToShowProp) || 5;
            },
            showNextButton: function () {
                if (this.totalPages === 1 || this.currentPage === this.totalPages) {
                    return false
                } else {
                    return true
                }
            },
            showPrevButton: function(){
                if (this.totalPages === 1 || this.currentPage === 1 ) {
                    return false
                } else {
                    return true
                }
            },
            // Generates the array that we loop through to create the paging items
            pages: function(){
                let start = 1; //Default min
                let end = this.maxPagesToShow; //The last paging item to show

                //Logic to decide the end variable (depending on what the current index is)
                if (this.totalPages > (this.currentPage + Math.ceil(this.maxPagesToShow / 2)) && this.currentPage <= Math.ceil(this.maxPagesToShow / 2)) {
                    end = this.currentPage + (this.maxPagesToShow - this.currentPage);
                } else if (this.totalPages > (this.currentPage + Math.ceil(this.maxPagesToShow / 2))) {
                    end = this.currentPage + Math.ceil(this.maxPagesToShow / 2 - (this.maxPagesToShow % 2 === 0 ? 0 : 1));
                } else {
                    end = this.totalPages;
                }

                // Let's just make completely sure we didn't go too far
                if (end > this.totalPages) {
                    end = this.totalPages;
                }

                //Logic to decide the start variable (depending on what the current index is)
                if (this.currentPage > Math.ceil(this.maxPagesToShow / 2) && (this.currentPage + Math.ceil(this.maxPagesToShow / 2)) > this.totalPages ) {
                    start = this.currentPage - ((this.maxPagesToShow - 1) - (this.totalPages - this.currentPage));
                } else if (this.currentPage > Math.ceil(this.maxPagesToShow / 2)) {
                    start = this.currentPage - Math.ceil(this.maxPagesToShow / 2 - 1);
                }

                // Let's just make completely sure we didn't go too far
                if (start < 1) {
                    start = 1;
                }

                return Array(end - start + 1).fill().map((_, idx) => start + idx)
            }
        },
        methods: {
            go(page){
                if(page > 0 && page <= this.totalPages){
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    let tab = urlParams.get('tab');
                    if (!tab){
                        tab = "unanswered";
                    }
                    let urlparam = "?tab="+tab+"&page="+page;
                    history.pushState({page: 1}, "title 1", urlparam);
                    this.$emit('changed', page);

                    if (document.getElementById('mypages-menu__list')) {
                        document.getElementById('mypages-menu__list').scrollIntoView();
                    } else if (document.getElementsByClassName("c-o-search-header__meta")) {
                        document.getElementsByClassName("c-o-search-header__meta")[0].scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                    
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculePagination.vue